
import { PARTICIPANT_ID_CHANGED } from '../base/participants';
import { ReducerRegistry } from '../base/redux';

import {
    SELECT_LARGE_VIDEO_PARTICIPANT,
    SET_LARGE_VIDEO_FULLSCREEN,
    SET_LARGE_VIDEO_LAST_DOMINANT_SPEAKER,
    SET_NATIVE_FULLSCREEN,
    TOGGLE_SIDEBAR_MENU,
    UPDATE_KNOWN_LARGE_VIDEO_RESOLUTION, UPDATE_LAST_LARGE_VIDEO_MEDIA_EVENT
} from './actionTypes';

const DEFAULT_STATE = {
    isSidebarMenuOpen: true,
    isNativeFullScreen: false,
    largevideofullscreen: false
};

// Minimum time (ms) between automatic participant updates to prevent flickering.
const MIN_AUTO_UPDATE_INTERVAL = 180;

ReducerRegistry.register('features/large-video', (state = DEFAULT_STATE, action) => {
    switch (action.type) {

    // When conference is joined, we update ID of local participant from default
    // 'local' to real ID. However, in large video we might have already
    // selected 'local' as participant on stage. So in this case we must update
    // ID of participant on stage to match ID in 'participants' state to avoid
    // additional changes in state and (re)renders.
    case PARTICIPANT_ID_CHANGED:
        if (state.participantId === action.oldValue) {
            return {
                ...state,
                participantId: action.newValue
            };
        }
        break;

    case SELECT_LARGE_VIDEO_PARTICIPANT: {
        if (state.participantId === action.participantId) {
            return state;
        }

        const now = Date.now();
        const lastUpdate = state._lastParticipantUpdateTime || 0;
        const selectionSource = action.selectionSource || 'auto';
        const isAutoSelection = selectionSource === 'auto' || selectionSource === 'dominant-speaker';

        if (!action.forceSelection && isAutoSelection && now - lastUpdate < MIN_AUTO_UPDATE_INTERVAL) {
            return state;
        }

        return {
            ...state,
            participantId: action.participantId,
            _lastParticipantUpdateTime: now,
            _lastSelectionSource: selectionSource
        };
    }

    case SET_LARGE_VIDEO_FULLSCREEN:
        return {
            ...state,
            largevideofullscreen: action.largevideofullscreen
        };

    case TOGGLE_SIDEBAR_MENU:
        return {
            ...state,
            isSidebarMenuOpen: action.isSidebarMenuOpen
        };

    case SET_NATIVE_FULLSCREEN:
        return {
            ...state,
            isNativeFullScreen: action.isNativeFullScreen
        };

    case UPDATE_KNOWN_LARGE_VIDEO_RESOLUTION:
        return {
            ...state,
            resolution: action.resolution
        };

    case UPDATE_LAST_LARGE_VIDEO_MEDIA_EVENT:
        return {
            ...state,
            lastMediaEvent: action.name
        };

    case SET_LARGE_VIDEO_LAST_DOMINANT_SPEAKER:
        if (state._lastDominantSpeakerId === action.participantId) {
            return state;
        }

        return {
            ...state,
            _lastDominantSpeakerId: action.participantId
        };

    }

    return state;
});
